import React from "react"
import { get } from "lodash"
import { ToastStateType } from "redux/ducks/Toast"
import { ToastMessage } from "components/utils/toast"
import { connect } from "react-redux"

type Toast = {
  toast: ToastStateType
}

export const Toast: React.FC<Toast> = props => {
  return (
    <ToastMessage
      show={get(props.toast, "show")}
      headerMessage={get(props.toast, "message.headerMessage")}
      bodyMessage={get(props.toast, "message.bodyMessage")}
    />
  )
}

export default connect((state: { toast: ToastStateType }) => {
  return { toast: state.toast }
})(Toast)
